// 3rd party Modules
import * as React from 'react';

// Components
import MyOCAccount from './myoc-account';
import Panel from './components/panel';
// import Profile from "./components/profile";
// import Settings from "./components/settings";
// import Subscriptions from "./components/subscriptions";
// import ResetPassword from "./components/reset-password";
// import Verification from "./components/verify-account";
// import ExpiredLink from "./components/expired-link";
// import ResendLink from "./components/resend-link";

// NOTE: following components need new designs
// import Login from "./components/login";
// import Signup from "./components/signup";
// import ForgotPassword from "./components/forgot-password";
// import ForgotPasswordComplete from "./components/forgot-password-complete";

// NOTE: following components crash page
// import Unsubscribe from "./components/unsubscribe";

// Providers
import { ServicesContext } from '~/providers/services-context';

// Services
// TODO: reintroduce refactored RequestService
// import RequestService from "~/services/actions/requests-actions";

// Stores
// import store from './myoc.store';

// Context
import { ModalProviderData, ModalView } from '~/providers/modal-context';

// Utils
import {
  getQueryParam,
  gtmTrackingLogInClicked } from
'~/components/Header/lib/util/utils';

// Types
import { type LoaderProviderData } from '~/providers/loader-context';
import { type MyOCData } from '~/types/myoc';

interface IProps {
  modalContext: ModalProviderData;
  viewToOpen: 'Signup' | 'Login' | 'Profile';
  loaderData: LoaderProviderData;
  myocData: MyOCData;
}

interface IState {
  shouldRedirect: boolean;
}

// Styles
import styles from './style/myoc-controller.module.css';

class MyOCController extends React.Component<IProps, IState> {
  static contextType = ServicesContext;

  // private requestService: RequestService;
  private panels: Panel[];

  constructor(
  public props: IProps,
  public state: IState)
  {
    super(props);

    // this.requestService = RequestService.getInstance();

    // TODO: we need to reintroduce + test all of these views
    // as well as updating the styles + imports to new stack
    this.panels = [
      // new Panel(<Profile />, "Profile"),
      // new Panel(<Settings />, "Settings"),
      // new Panel(<Subscriptions />, "Subscriptions"),
      // new Panel(<ResetPassword />, "ResetPassword", "reset-password"),
      // new Panel(<Verification />, "Verification"),
      // new Panel(<ExpiredLink />, "ExpiredLink"),
      // new Panel(<ResendLink />, "ResendLink"),
      // NOTE: following views need new designs
      // new Panel(<Login showSocialLoginButtons />, "Login"),
      // new Panel(<Signup />, "Signup"),
      // new Panel(<ForgotPassword />, "ForgotPassword"),
      // new Panel(<ForgotPasswordComplete />, "ForgotPasswordComplete"),
      // NOTE: following views crash page
      // new Panel(<Unsubscribe />, "Unsubscribe"),
    ];

    this.state = {
      shouldRedirect: false
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (typeof window === 'undefined') return;

    if (!window.ocAuth) {
      window.addEventListener('OC:ocAuthReady', () => {
        this.triggerOCAuth(this.defaultPanel());
        this.forceUpdate();
      });
    }

    this.triggerOCAuth(this.defaultPanel());
  }

  componentDidUpdate(prevProps: IProps, prevState: IState): void {
    if (!prevState.shouldRedirect && this.state.shouldRedirect) {
      this.handleClose();
    }

    // Ensure we trigger oc auth on new props
    if (
    prevProps.viewToOpen !== this.props.viewToOpen ||
    prevProps.myocData?.view !== this.props.myocData?.view ||
    prevProps.myocData?.isLoggedIn !== this.props.myocData?.isLoggedIn)
    {
      this.triggerOCAuth(this.defaultPanel());
    }
  }

  private handleClose(): void {
    const isInMyOddschecker =
    window.location.href.indexOf('myoddschecker') !== -1;
    const hadToAcceptNewTerms = getQueryParam('policyupdaterequired');

    if (isInMyOddschecker) {
      // in case of being in any of the myoddschecker urls, we need to redirect to the homepage of the repub
      // it is also the case if the user came from the GDPR email, in which we need to take the argument out of the url
      const _urlToGo = hadToAcceptNewTerms ?
      this.props.loaderData.baseUrl :
      window.location.href;

      // TODO: reintroduce OR refactor to fetch
      // this.requestService.getUrl(urlToGo).then((res) => {
      //   this.context.linkActions.newPage(urlToGo, res.data);
      // });
    }
  }

  private defaultPanel(): string {
    const { myocData, viewToOpen } = this.props;

    switch (true) {
      case myocData?.view === 'User':
      case viewToOpen === 'Login' && myocData?.isLoggedIn:
        return 'Profile';
      case viewToOpen === 'Profile' && myocData?.view === 'Settings':
        return 'Settings';

      default:
        return viewToOpen || myocData?.view;
    }
  }

  private triggerOCAuth(defaultView: string): void {
    if (typeof window === 'undefined' || typeof window.ocAuth === 'undefined') {
      return;
    }

    const { myocData, loaderData } = this.props;
    const { apiResponse, currentPath } = loaderData;

    const isSignup = defaultView === 'Signup';
    const isLogin = defaultView === 'Login' || currentPath === 'login';
    const isVerification =
    defaultView === 'Verification' || currentPath === 'verifyAccount';

    const shouldTriggerSignupModal = !myocData?.isLoggedIn && isSignup;
    const shouldTriggerLoginModal = !myocData?.isLoggedIn && isLogin;
    const shouldTriggerLoginModalFromEmailVerification =
    !myocData?.isLoggedIn && isVerification && apiResponse?.success;

    const [_, dispatchFromContext] = this.props.modalContext;

    switch (true) {
      case shouldTriggerSignupModal:
        dispatchFromContext({
          type: 'SET_VIEW',
          payload: { view: ModalView.SignupForm }
        });
        window.ocAuth.isNavbarSignup = true;
        break;

      case shouldTriggerLoginModal:
        gtmTrackingLogInClicked();
        dispatchFromContext({
          type: 'SET_VIEW',
          payload: { view: ModalView.LoginForm }
        });
        window.ocAuth.isNavbarLogin = true;
        break;

      case shouldTriggerLoginModalFromEmailVerification:
        dispatchFromContext({
          type: 'SET_VIEW',
          payload: { view: ModalView.LoginVerificationForm }
        });
        break;

      default:
        break;
    }
  }

  public render(): JSX.Element | null {
    const { myocData, viewToOpen } = this.props;

    if (!myocData && !viewToOpen) {
      return null;
    }

    return (
      <div className={styles.myOddsChecker}>
				<MyOCAccount
          defaultPanel={this.defaultPanel()}
          panels={this.panels}
          maxHistory={3}
          handleClose={this.handleClose} />

			</div>);

  }
}

export default MyOCController;